<projects-users-teams-selection [data]="data" (backButtonClick)="onClose()"></projects-users-teams-selection>
